// export class NdbkSession {
//     constructor() {
//         this.user = null
//     }
// }

const _ = (method, url, body, success, fail) => {

    const _domain = ((process.env.REACT_APP_NDBK_MODE==="dev")
        ? "http://localhost:3001/api"
        : "https://nodebook.io/api");

    return fetch(`${_domain}${url}`, {
        method: method,
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: body?JSON.stringify(body):undefined
    })
        .then(response => {
            // neither was passed, so it's probably Promise.all etc
            if (!success && !fail) {
                return response.json()
            }

            if (response.ok && success) {
                response.json().then(json=>success(json))

            }
            else if (!response.ok && fail) {
                response.json().then(json=>fail(json))
                // throw Error(response.statusText)
            }

        })
        .catch((error) => {
                console.error(error);
        });
}

export default class NdbkAPI {}

NdbkAPI.admin = {
    getAllNodes: (success, fail) => _('GET', '/admin/nodes', null, success, fail),
    updateAllNodes: (nodes, success, fail) => _('PUT', '/admin/nodes/update', {nodes: nodes}, success, fail),
    record: (type, content) => _('POST', '/admin/activity', {type: type, content: content}, null, null)
}

NdbkAPI.auth = {
    check: (success, fail) => _('GET', '/logged_in', null,
        data => {
            if (!success) {
                return
            }
            data.user.isGuest = false
            data.success = true
            success(data)
        }, response => {
            if (!fail) {
                return
            }
            let data = {
                user: {
                    isGuest: true
                },
                success: true
            }
            fail(data)
        }),
    login: (body, success, fail) => _('POST', '/login', body, success, fail),
    logout: (success, fail) => _('GET', '/logout', null, success, fail),
    loginGoogle: (success, fail) => _('POST', '/auth/google', null, success, fail),
    loginTwitter: (success, fail) => _('POST', '/auth/twitter', null, success, fail),
    register: (body, success, fail) => _('POST', '/register', body, success, fail)
}
NdbkAPI.users = {
    search: (text, success, fail) => _('GET', `/search/users/${text}`, null, success, fail),
    get: null,          // username
    getByID: null,      // id
    update: null,       // diff (updates current user)
}
NdbkAPI.nodebooks = {
    get: (id, success, fail) => _('POST', `/nodebook/${id}`, null, success, fail),
    search: null, // query
    create: null,
    getAll: null, // from current user
    getFrom: null, // from exact user
    update: (id, body, success, fail) => _('PUT', `/nodebook/${id}/update`, body, success, fail),
    delete: null,

    favorite: null, // favorite/unfavorite, like/unlike

    permissions: {
        add: null,
        get: (id, success, fail) => _('POST', `/nodebook/${id}/users`, null, success, fail),
        update: null,
        delete: null
        // move to group?
    },

    comments: {
        add: null,
        getAll: null,
        update: null,
        delete: null
    },

    // versioning: {
    //     commit: null,  // publish, commit
    //     clone: null,
    //     branches: null,
    //     suggest: null // pull request, suggest
    // }

    // layers: {
    //     add: null,
    //     getAll: null,
    //     update: null,
    //     delete: null
    // }
}
NdbkAPI.nodes = {
    search: null,
    create: null,
    get: (ndbkId, success, fail) => _('POST', `/nodebook/${ndbkId}/nodes`, null, success, fail),
    update: null,
    delete: null,

    comments: {
        add: null,
        getAll: null,
        update: null,
        delete: null
    },
}
NdbkAPI.links = {
    create: null,
    get: (ndbkId, success, fail) => _('POST', `/nodebook/${ndbkId}/links`, null, success, fail),
    update: null,
    delete: null,

    comments: {
        add: null,
        getAll: null,
        update: null,
        delete: null
    },
}
NdbkAPI.files = {
    bibtex: null,
    upload: null,
    parsePDF: null,
}
NdbkAPI.misc = {
    fetchURLMetaData: (body, success, fail) => _('POST', '/fetch-meta-data', body, success, fail),
}
// NdbkAPI.groups = {
//     // ...TODO
// }
// NdbkAPI.organizations = {
//     // ...TODO
// }
// NdbkAPI.notifications = {
//     // ...TODO
// }
// NdbkAPI.messages = {
//     // ...TODO
// }
// TODO subscriptions...


// WEBPACK FOOTER //
// ./src/ndbk-api.js